import { render, staticRenderFns } from "./TaskFormDialog.vue?vue&type=template&id=6455251e"
import script from "./TaskFormDialog.vue?vue&type=script&lang=js"
export * from "./TaskFormDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports